module.exports = __webpack_public_path__ + "static/media/error.a31d0e8c.png";